import React from 'react'
//import getConfig from 'next/config'

import { style } from '../../../../components/Common/Index.style'
import Page from '../../../../components/Page/Page'
import PageHeader from '../../../../components/PageHeader/PageHeader'
import Content from '../../../../components/Content/Content'
import SectionTitle from '../../../../components/SectioinTitle'
import BackBtn from '../../../../components/Common/BackBtn'
import BreadCrumb from '../../../../components/Breadcrumbs/Breadcrumbs'

//const { publicRuntimeConfig } = getConfig()
//const basePath = publicRuntimeConfig.basePath

const pageTitle = '東京圏から新潟県へ移住する子育て世帯の方に支援金（最大50万円）を支給します | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="県からのお知らせ" />
      <SectionTitle sectionTitle="東京圏から新潟県へ移住する子育て世帯の方に支援金（最大50万円）を支給します" />
      <Content css={style.content}>
        <BreadCrumb
            lists={[
              {
                name: "HOME",
                path: "/"
              },
              {
                name: "2024夏号 No.167 目次",
                path: "/no167"
              },
              {
                name: "県からのお知らせ"
              }
            ]}
          />
        
        
        <p><span css={style.emphasisWeight}>対象</span>&emsp;令和6年4月1日以降に東京圏（埼玉県、千葉県、東京都、神奈川県）から県内市町村に18歳未満の者を帯同して移住する場合で、就業等の一定の条件を満たす方</p>
        
        <p>詳しくは
          <a
            href="https://www.pref.niigata.lg.jp/sec/shigototeijyu/r6kosodateijyusiennkinn060401.html"
            target="_blank"
            rel="noreferrer"
          >
            <span>こちら</span>
          </a>
        </p>
        
        <p>※申請先は、移住（予定）先の市町村となります。<br />
          ※市町村によって事業実施の有無、支給条件等が異なります。<br />
          ※一定期間内に転出等をした場合、支援金を返還いただく可能性があります。</p>
        
        <p>【問い合わせ】しごと定住促進課&emsp;電話：<a href="tel:025-280-5635">025-280-5635</a></p>
        
        <BackBtn href={"/no167"} />
      </Content>
    </Page>
  )
}
export default Home
